
import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="py-20 animate-fade-in">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-9xl font-bold text-primary/20">404</h1>
        <h2 className="text-2xl font-bold text-white mb-4">Page Not Found</h2>
        <p className="text-slate-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link to="/">
            <button className="inline-flex items-center gap-2 px-4 py-2 bg-primary hover:bg-primary-dark text-white rounded-lg transition-colors">
              <Home className="w-4 h-4" />
              Go Home
            </button>
          </Link>
          <Link to="/tools">
            <button className="inline-flex items-center gap-2 px-4 py-2 bg-surface hover:bg-slate-700 text-slate-300 rounded-lg border border-slate-700 transition-colors">
              <Search className="w-4 h-4" />
              Browse Tools
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
